import { useMapContext } from "../context/MapContext";

export const useURLChanged = () => {
	const {
		state: { currAssetId, clicked },
		actions: { setCurrAssetId, setLoadingMap, setClicked },
	} = useMapContext();

	return () => {
		const currentURL = location.pathname;
		if (!clicked) {
			let str = "";
			let car = "";
			for (let i = currentURL.toString().length - 1; i > 0; i--) {
				if (currentURL.toString()[i] === "-") break;
				if (currentURL.toString()[i] != "-") {
					car = currentURL.toString()[i];
					str = car.toString() + str;
				}
			}
			if (!isNaN(Number(str))) {
				if (Number(str) != currAssetId) {
					setLoadingMap(true);
					setCurrAssetId(Number(str));
				}
			}
		} else setClicked(false);
	};
};
